// 휴대폰번호
export const mobileRegex = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;

// 이메일
export const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

// 생년월일
export const birthRegex = /^[0-9]{6}$/;

// 주민등록번호
export const juminRegex = /^[0-9]{13}$/;

// 사업자등록번호
export const bizIdRegex = /^[0-9]{10}$/;

// 웹사이트 주소
export const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

// 전화번호
export const telRegex = /^(01[016789]\d{7,8}|0[2-9]\d{1,2}\d{6,8})$/;

// 리워드 팔찌 각인
export const fourthRegex = /^[A-Z]{1,5}$/;

// user id
export const userIdRegex = /^[a-z0-9-_]+$/;

// 비밀번호 - 영문+숫자+허용특수문자 포함 여부
export const passwdRegex = /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%*?&^()+=-])/;

// 비밀번호 - 허용되지 않는 문자 포함 여부 (영문, 숫자, 허용 특수문자 외의 문자)
export const passwdDisallowedRegex = /[^a-zA-Z0-9!@#$%*?&^()+=-]/;

// 생년월일 8자리 (YYYYMMDD)
export const birthRegex8 = /^[0-9]{8}$/;

// 팩스번호 (하이픈 포함/미포함 모두 허용, 숫자 9~11자리)
export const faxRegex = /^(02|0[3-9]\d)-?(\d{3,4})-?(\d{4})$/;

// 우편번호 (7자 이하 숫자)
export const zipCodeRegex = /^[0-9]{1,7}$/;

// SF 필드 길이 제한 상수
export const SF_MAX_EMAIL_LENGTH = 80;
export const SF_MAX_ADDRESS_LENGTH = 255;
export const SF_MAX_NAME_LENGTH = 80;
export const SF_MAX_AMOUNT_LENGTH = 16;
export const SF_MAX_ZIPCODE_LENGTH = 7;

// 생년월일 유효성 검증 (SF 기준: 최소 1900-01-01, 미래날짜 불가)
export const isValidBirthdate = (value: string): string | true => {
  if (!value) return true;
  const stripped = value.replace(/-/g, '');
  if (!/^[0-9]{8}$/.test(stripped)) return '생년월일 8자리를 정확히 입력해주세요 (YYYYMMDD)';

  const year = parseInt(stripped.substring(0, 4), 10);
  const month = parseInt(stripped.substring(4, 6), 10);
  const day = parseInt(stripped.substring(6, 8), 10);

  if (year < 1900) return '입력 가능한 최소 연도는 1900년입니다';
  if (month < 1 || month > 12) return '올바른 월을 입력해주세요 (01~12)';
  if (day < 1 || day > 31) return '올바른 일을 입력해주세요 (01~31)';

  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return '존재하지 않는 날짜입니다';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (date > today) return '미래 날짜는 입력할 수 없습니다';

  return true;
};
